<template>

<core-panel>

	<template v-slot:head>

		<h1>Most Games</h1>

		<p>The people who have played the most different games.</p>

	</template>

	<template v-slot:body>

		<app-user type="player" :item="item" v-for="(item, index) in mostgames" :subtext="item.plays + ' play' + ((item.plays > 1) ? 's' : '')" count-text="game" :key="index" />

	</template>

</core-panel>

</template>

<script>

import Panel from './../../common/Panel'

export default {

	mixins: [Panel],

	data: function() {

		return {
			detail: 'mostgames',
			mostgames: []
		}

	},

	methods: {

		response: function(json) {

			this.mostgames = json.mostgames.players

		}

	}

}

</script>